export const languageTitles: Record<string, string> = {
  en: "English",
  es: "Español",
  kk: "Қазақша",
  pt: "Português",
  ro: "Română",
  ru: "Русский",
  uk: "Українська",
};
